module.exports = __webpack_public_path__ + "img/solution31.3ddd8a62.png";